import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  rightSideButtonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: 10,
  },
  header: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'InterSemiBold',
    paddingBottom: 5,
  },
  ellipsisBtn: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: 'white',
  },
  menuWrapper: {
    position: 'absolute',
    zIndex: 100,
    borderRadius: 8,
    backgroundColor: 'white',
  },
  menuButtonWrapper: {
    borderColor: colors.newUI.therapist.brandGreen,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: 'white',
    borderRadius: 8,
    minWidth: 250,
    elevation: 5,
    shadowColor: colors.newUI.therapist.shadow,
    shadowOffset: { width: -11, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 26,
  },
  checkboxWrapper: {
    width: '100%',
    backgroundColor: colors.newUI.therapist.grey20,
    padding: 5,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: colors.newUI.therapist.grey30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
